{
  "customer_support_tool_name": "Common Daas: Customer support tool",
  "closeCustomerDesktop": "Close customer",
  "closeCustomerMobile": "Close"
}
